import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as componentTypes from "../../../../../constants/componentTypes";
import * as navigationActions from "../../../../../actions/navigationActions";

class ModifiedOrderModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleConfirmClick = () => {
        if (Array.isArray(this.props.params)) {
            for (let nextAction of this.props.params) {
                this.props.dispatchAction(nextAction);
            }
        }

        this.props.dispatchCloseModalAction();
    };

    render() {
        return (
            <div id="modal" className="default-modal ig-restart-modal ig-small-modal">
                <div className="modal-content">
                    <div className="col-xs-12">
                        <Translate value="customRedlike.orderModification" />
                    </div>
                    <div className="modal-footer">
                        <div className="col-xs-6 text-right">
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleCloseModalClick}>
                                <span className="glyphicon glyphicon-menu-right" />
                                <Translate value="general.cancel" />
                            </button>
                        </div>
                        <div className="col-xs-6 text-left ">
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleConfirmClick}>
                                <span className="glyphicon glyphicon-menu-right" />
                                <Translate value="general.confirm" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchAction: (nextAction) => {
            dispatch(nextAction);
        },
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.MODIFIED_ORDER_MODAL));
        }
    };
};

export default ModifiedOrderModal = connect(mapStoreToProps, mapDispatchToProps)(ModifiedOrderModal);
